'use strict';

var template = require('./item.html');

module.exports.directive = [
  FormItemDirective];

module.exports.controller = [
  '$scope',
  FormItemController];

function FormItemDirective() {
  return {
    restrict: 'E',
    template: template,
    scope: {
      model: '='
    },
    controllerAs: 'formItem',
    bindToController: true,
    controller: 'FormItemController'
  };
}

function FormItemController($scope) {

}


// WEBPACK FOOTER //
// ./src/js/forms/directives/item/FormItemDirective.js